import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { openModal } from '../../../../store/actions/modal';

const top = (props) => {
	const {
		clickType,
		dispatch,
	} = props;

	const onClick = (event) => {
		event.preventDefault();
		dispatch(openModal(clickType, {}));
	};

	return (
		<div className="B13-quick-links-login__view">
			<h3 className="B13-quick-links-login__h3">Registered Users</h3>
			<h2 className="B13-quick-links-login__title">
				Sign in to get full access of resources
			</h2>
			<a
				className="B13-quick-links-login__button btn btn--secondary btn--inverted"
				href="/"
				onClick={onClick}
			>
				Login
				<span className="btn__arrow-angle" />
			</a>
		</div>
	);
};

top.propTypes = {
	clickType: PropTypes.string.isRequired,
	dispatch: PropTypes.func.isRequired,
};

export default connect()(top);
